export type PlanLevels = Record<string, number>;

export const DEFAULT_PLAN_LEVELS: PlanLevels = {
  '*': 0,
  starter: 10,
  pro: 20,
  max: 30,
  ultra: 40,
  enterprise: 50,
};

export type PlanCode = keyof typeof DEFAULT_PLAN_LEVELS;

function normalizePlanCode(plan: string | null | undefined): string {
  return String(plan ?? '*').trim().toLowerCase();
}

export function planLevel(
  plan: string | null | undefined,
  levels: PlanLevels = DEFAULT_PLAN_LEVELS,
): number {
  const normalized = normalizePlanCode(plan);
  const level = levels[normalized];
  return Number.isFinite(level) ? level : 0;
}

export function hasPlanAtLeast(
  plan: string | null | undefined,
  requiredPlan: string,
  levels: PlanLevels = DEFAULT_PLAN_LEVELS,
): boolean {
  const required = normalizePlanCode(requiredPlan);
  if (required !== '*' && !Number.isFinite(levels[required])) return false;
  return planLevel(plan, levels) >= planLevel(required, levels);
}
